import React, { useEffect, useRef, useState } from "react";
import { CloseModal, SuccessIcon } from "../assets/icons/ModalIcons";
import xss from "xss";

const SlicesStepper = ({
  stepsConfig = [],
  privacyPolicy,
  formClass,
  heading,
  description,
}) => {
  const [currentStep, setCurrentStep] = useState(1);
  const [isComplete, setIsComplete] = useState(false);
  const [margins, setMargins] = useState({
    marginLeft: 0,
    marginRight: 0,
  });
  const [showComplete, setShowComplete] = useState(false);
  const stepRef = useRef([]);

  useEffect(() => {
    setMargins({
      marginLeft: stepRef.current[0]?.offsetWidth / 2,
      marginRight: stepRef.current[stepsConfig.length - 1]?.offsetWidth / 2,
    });
  }, [stepRef, stepsConfig.length, currentStep]);

  if (!stepsConfig.length) {
    return <></>;
  }

  const handleNext = () => {
    setCurrentStep((prevStep) => {
      if (prevStep === stepsConfig.length) {
        setIsComplete(true);
        setShowComplete(true);
        return prevStep;
      } else {
        return prevStep + 1;
      }
    });
  };

  const calculateProgressBarWidth = () => {
    return ((currentStep - 1) / (stepsConfig.length - 1)) * 100;
  };

  const continueBrowsing = () => {
    setCurrentStep(1);
    setShowComplete(false);
  };
  const ActiveComponent = stepsConfig[currentStep - 1]?.Component;
  return (
    <>
      {!showComplete && (
        <section>
          <div
            className={`stepper gap-5 ${currentStep === 1 ? "!hidden" : "block"}`}
          >
            {stepsConfig.map((step, index) => {
              return (
                <div
                  key={step.name}
                  ref={(el) => (stepRef.current[index] = el)}
                  className={`step ${
                    currentStep > index + 1 || isComplete ? "complete" : ""
                  } ${currentStep === index + 1 ? "active" : ""} `}
                >
                  <div className="text-xs step-number">{index + 1}</div>

                  <div className="text-xs text-gray-600 mt-1.5 text-center">
                    {step.name}
                  </div>
                </div>
              );
            })}

            <div
              className="progress-bar"
              style={{
                width: `calc(100% - ${margins?.marginLeft + margins?.marginRight}px)`,
                marginLeft: margins?.marginLeft,
                marginRight: margins?.marginRight,
                backgroundColor:
                  margins?.marginLeft === 0 && margins?.marginRight === 0
                    ? "white"
                    : "#DFDFDF",
              }}
            >
              <div
                className="progress"
                style={{ width: `${calculateProgressBarWidth()}%` }}
              ></div>
            </div>
          </div>

          <h4
            className={`text-purple-1100 text-2xl tracking-tightest_5 font-semibold font-manrope flex items-center gap-2 ${currentStep !== 1 && "mt-6"} `}
          >
            <svg
              className="hidden sm:block"
              xmlns="http://www.w3.org/2000/svg"
              width="32"
              height="32"
              viewBox="0 0 32 32"
              role="presentation"
              fill="none"
            >
              <path
                d="M25.7555 21.8719C24.9733 21.0891 24.0594 20.4501 23.0555 19.9844C24.4712 18.8375 25.3743 17.0875 25.3743 15.125C25.3743 11.6625 22.4868 8.82188 19.0243 8.875C15.6149 8.92813 12.868 11.7063 12.868 15.125C12.868 17.0875 13.7743 18.8375 15.1868 19.9844C14.1827 20.4498 13.2687 21.0888 12.4868 21.8719C10.7805 23.5813 9.81179 25.8375 9.74929 28.2437C9.74845 28.2771 9.7543 28.3103 9.76649 28.3413C9.77868 28.3724 9.79696 28.4007 9.82026 28.4246C9.84356 28.4485 9.8714 28.4674 9.90215 28.4804C9.9329 28.4933 9.96592 28.5 9.99929 28.5H11.7493C11.8837 28.5 11.9962 28.3937 11.9993 28.2594C12.0587 26.4469 12.793 24.75 14.0837 23.4625C14.7441 22.7986 15.5297 22.2722 16.3949 21.9139C17.2601 21.5555 18.1878 21.3724 19.1243 21.375C21.0274 21.375 22.818 22.1156 24.1649 23.4625C25.4524 24.75 26.1868 26.4469 26.2493 28.2594C26.2524 28.3937 26.3649 28.5 26.4993 28.5H28.2493C28.2826 28.5 28.3157 28.4933 28.3464 28.4804C28.3772 28.4674 28.405 28.4485 28.4283 28.4246C28.4516 28.4007 28.4699 28.3724 28.4821 28.3413C28.4943 28.3103 28.5001 28.2771 28.4993 28.2437C28.4368 25.8375 27.468 23.5813 25.7555 21.8719ZM19.1243 19.125C18.0555 19.125 17.0493 18.7094 16.2962 17.9531C15.9182 17.5781 15.6196 17.1309 15.4183 16.638C15.217 16.1451 15.117 15.6167 15.1243 15.0844C15.1337 14.0594 15.543 13.0688 16.2587 12.3344C17.0087 11.5656 18.0118 11.1375 19.0837 11.125C20.143 11.1156 21.1712 11.5281 21.9274 12.2688C22.7024 13.0281 23.1274 14.0438 23.1274 15.125C23.1274 16.1938 22.7118 17.1969 21.9555 17.9531C21.5845 18.3259 21.1432 18.6214 20.6573 18.8226C20.1713 19.0237 19.6502 19.1265 19.1243 19.125ZM11.2962 15.95C11.268 15.6781 11.2524 15.4031 11.2524 15.125C11.2524 14.6281 11.2993 14.1438 11.3868 13.6719C11.4087 13.5594 11.3493 13.4438 11.2462 13.3969C10.8212 13.2063 10.4305 12.9438 10.093 12.6125C9.69535 12.2269 9.3824 11.7626 9.17418 11.2493C8.96595 10.736 8.867 10.1849 8.88366 9.63125C8.91179 8.62813 9.31491 7.675 10.018 6.95625C10.7899 6.16563 11.8274 5.73438 12.9305 5.74688C13.9274 5.75625 14.8899 6.14063 15.618 6.82188C15.8649 7.05313 16.0774 7.30938 16.2555 7.58438C16.318 7.68125 16.4399 7.72188 16.5462 7.68438C17.0962 7.49375 17.6774 7.35938 18.2743 7.29688C18.4493 7.27813 18.5493 7.09063 18.4712 6.93438C17.4555 4.925 15.3805 3.5375 12.9805 3.5C9.51491 3.44688 6.62741 6.2875 6.62741 9.74688C6.62741 11.7094 7.53053 13.4594 8.94616 14.6063C7.95241 15.0656 7.03679 15.7 6.24304 16.4938C4.53053 18.2031 3.56178 20.4594 3.49928 22.8687C3.49845 22.9021 3.5043 22.9353 3.51649 22.9663C3.52868 22.9974 3.54696 23.0257 3.57026 23.0496C3.59356 23.0735 3.6214 23.0924 3.65215 23.1054C3.68289 23.1183 3.71592 23.125 3.74928 23.125H5.50241C5.63679 23.125 5.74929 23.0187 5.75241 22.8844C5.81179 21.0719 6.54616 19.375 7.83679 18.0875C8.75554 17.1688 9.88054 16.5312 11.1087 16.2219C11.2305 16.1906 11.3118 16.075 11.2962 15.95Z"
                fill="#1D0642"
              />
            </svg>
            {heading}
          </h4>
          <p className="text-gray-1200 text-sm tracking-wider mt-2.5">
            {description}
          </p>

          {ActiveComponent(handleNext, formClass)}
          <div
            className="text-xs font-normal text-center text-gray-600 font-inter trail_anchor_link"
            dangerouslySetInnerHTML={{
              __html: xss(privacyPolicy),
            }}
          />
        </section>
      )}

      {showComplete && (
        <div className="w-full max-w-xs px-5 py-6 overflow-hidden text-left align-middle sm:max-w-lg sm:p-9">
          <div className="flex flex-col items-center justify-between gap-y-3">
            <SuccessIcon />
            <h4 className="text-2xl font-semibold text-purple-1100 tracking-tightest_5 font-manrope">
              We’ve got your request!
            </h4>
          </div>
          <div className="px-5 mt-3 sm:px-0">
            <p className="text-xs font-medium text-center sm:text-base text-gray-1200 tracking-tighter_1">
              Thank you for submitting the form. Someone from our team will get
              in touch with you as soon as possible.
            </p>
          </div>
          <button
            type="button"
            onClick={continueBrowsing}
            className="bg-purple-1500 hover:bg-purple-400 font-semibold text-white py-2.5 px-7 tracking-tighter_1 sm:text-lg text-base shadow-lg rounded-full w-full mx-auto sm:mt-5 mt-3.5"
          >
            Continue Browsing
          </button>
        </div>
      )}
    </>
  );
};

export default SlicesStepper;
